<template>
    <div class="step-card rounded h-100 w-100 pa-20 pa-md-30 py-lg-54 d-flex flex-column align-center text-center">
        
        <sub-icon-primary
        spacing="mb-14 mb-lg-20"
        bgColor="#fff"
        size="icon-priamry--lg"
        :icon="icon">
        </sub-icon-primary>

        <div class="step-card__step d-flex align-center justify-center line-height-1 mb-16 mb-lg-34">
            <h5 class="tit-txt font-weight-bold color-white text-center">
                STEP {{step}}
            </h5>
        </div>

        <h4 class="tit--sm font-weight-bold mb-4 mb-lg-10">
            {{tit}}
        </h4>

        <p class="page-text color-grey">
            {{sc1}}
        </p>
        <p class="page-text color-grey mt-2 mt-lg-6" v-if="sc2">
            {{sc2}}
        </p>
        <p class="page-text color-grey mt-2 mt-lg-6" v-if="sc3">
            {{sc3}}
        </p>
    </div>
</template>

<script>
import SubIconPrimary from "@/components/client/sub/sub-icon-primary.vue";
export default{
    props : {
        icon : {type :String, default : ""},
        step : {type :String, default : ""},
        tit : {type :String, default : ""},
        sc1 : {type :String, default : ""},
        sc2 : {type :String, default : ""},
        sc3 : {type :String, default : ""},
    },
	components: {
        SubIconPrimary,
	},
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>

<style scoped>
.step-card{
    background-color: #f7f8fa;
}
.step-card__step{
    width: 98px;
    height: 32px;
    border-radius: 16px;
    background-color: #2e60ef;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .step-card__step{
        width: 112px;
        height: 38px;
        border-radius: 19px;
    }
}
@media (min-width:1200px){
}

</style>